import { actions } from "./actions"

export let KPI = {
  actions,
}